import { Dialog, TextField as MuiTextField } from "@mui/material";
import styled from 'styled-components';
import {media} from '../../theme';

export const DropZone = styled.div<{ $isDraggingOver: boolean }>`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    background:  ${({$isDraggingOver, theme}) => (
        $isDraggingOver 
                ? theme.palette.action.hoveredDropzone
                : theme.palette.background.dropzone
    )};
    
    border: 2px dashed ${({$isDraggingOver, theme}) => (
        $isDraggingOver 
            ? theme.palette.dividers.strong 
            : theme.palette.divider
    )};
    border-radius: 8px;
    
    padding: 24px;
    transition: all 0.2s ease-in-out;
    cursor: pointer;

    p {
        color: ${({$isDraggingOver, theme}) => (
            $isDraggingOver 
                    ? theme.palette.action.dragDrop
                    : theme.palette.text.secondary
        )};
    }
`;

export const FileList = styled.ul`
    list-style-type: none;
    padding: 0;
    margin: 10px 0 0 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    gap: 12px;
    
    li {
        color: ${({theme}) => theme.palette.text.primary};
        font-size: ${({theme}) => theme.typography.body2.fontSize};
    }

    button {
        background: none;
        border: none;
        cursor: pointer;
        font-weight: ${({theme}) => theme.typography.button.fontWeight};
        color: ${({theme}) => theme.palette.text.primary};
        font-size: ${({theme}) => theme.typography.body2.fontSize};
    
        &:hover {
            color: ${({theme}) => theme.palette.action.delete};
        }
    }
`;

export const StyledDialog = styled(Dialog)`
    .MuiPaper-root {
        width: 100%;
        min-width: unset;

        ${media.sm} {
            min-width: 550px;
            width: 550px;
        }
    }
`;

export const ModalHeader = styled.h3`
    padding: 16px 24px;
    font-size: 1.25rem;
    font-weight: ${({theme}) => theme.typography.h3.semibold};
    margin: 0;
    text-align: left;
`;

export const ModalBody = styled.div`
    padding: 32px !important;
    display: flex;
    flex-direction: column;
    gap: 14px;
`;

export const ModalFooter = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    padding-top: 8px;
    padding-left: 24px;
    padding-bottom: 20px !important;
    padding-right: 20px !important;
`;